<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_24_404)">
            <rect width="36" height="36" fill="transparent" />
            <path
                d="M11.656 6C10.3477 6 9.28296 7.06471 9.28296 8.37305C9.28296 9.68139 10.3477 10.7461 11.656 10.7461C12.9643 10.7461 14.0291 9.68139 14.0291 8.37305C14.0291 7.06471 12.9643 6 11.656 6ZM11.656 9.16406C11.2199 9.16406 10.865 8.80916 10.865 8.37305C10.865 7.93693 11.2199 7.58203 11.656 7.58203C12.0921 7.58203 12.447 7.93693 12.447 8.37305C12.447 8.80916 12.0921 9.16406 11.656 9.16406Z"
                fill="url(#paint4_linear_24_404)"
            />
            <path
                d="M29.3383 18.8512C28.4487 17.8894 27.2949 17.2386 26.0308 16.9744C26.0124 13.3405 23.0503 10.39 19.4121 10.39C17.3059 10.39 15.3247 11.4052 14.086 13.0795C13.4073 12.8169 12.679 12.6797 11.9455 12.6797C8.68334 12.6797 6.02922 15.3339 6.02922 18.596C6.02922 19.2594 6.14207 19.9207 6.35881 20.5445C4.92074 21.3777 4 22.9318 4 24.6315C4 27.2339 6.11729 29.3512 8.71973 29.3512H24.7457C28.194 29.3512 31 26.5452 31 23.0969C31 21.5175 30.4099 20.0098 29.3383 18.8512Z"
                fill="url(#paint0_linear_24_404)"
            />
            <path
                opacity="0.1"
                d="M29.3383 18.855C28.4487 17.8932 27.2949 17.2424 26.0308 16.9782C26.0124 13.3443 23.0503 10.3938 19.4121 10.3938C17.3059 10.3938 15.3247 11.4089 14.086 13.0833C13.4073 12.8206 12.679 12.6835 11.9455 12.6835C8.68334 12.6835 6.02922 15.3376 6.02922 18.5998C6.02922 19.2632 6.14207 19.9245 6.35881 20.5483C4.92074 21.3815 4 22.9356 4 24.6352C4 27.2377 6.11729 29.355 8.71973 29.355H24.7457C28.194 29.355 31 26.549 31 23.1007C31 21.5213 30.4099 20.0136 29.3383 18.855ZM24.7457 27.7729H8.71973C6.98951 27.7729 5.58203 26.3655 5.58203 24.6352C5.58203 23.3174 6.41418 22.1314 7.65344 21.6832C8.09266 21.5363 8.30882 20.9843 8.08797 20.5779C7.77156 19.963 7.61125 19.2975 7.61125 18.5998C7.61125 16.2099 9.55557 14.2656 11.9455 14.2656C12.6621 14.2656 13.372 14.4438 13.9974 14.7808C14.3734 14.9838 14.8417 14.8514 15.0568 14.4823C15.9559 12.9367 17.625 11.9758 19.4121 11.9758C22.1891 11.9758 24.4488 14.2355 24.4488 17.0125C24.4488 17.1992 24.4388 17.3864 24.4182 17.5688C24.3618 17.9985 24.7065 18.4174 25.1391 18.4448C26.3019 18.5413 27.3808 19.0681 28.1771 19.9292C28.9771 20.7946 29.418 21.921 29.418 23.1007C29.418 25.6767 27.3218 27.7729 24.7457 27.7729Z"
                fill="url(#paint1_linear_24_404)"
            />
            <!-- <path
                d="M14.3773 20.9009C14.0426 20.6201 13.5436 20.6639 13.2629 20.9986C13.0787 21.2166 12.8393 21.3191 12.5218 21.3196C11.7789 21.3196 11.1746 20.7152 11.1746 19.9723C11.1746 19.2294 11.7789 18.6251 12.5218 18.6251C12.7919 18.6251 13.0522 18.7045 13.2745 18.8547C13.6365 19.0992 14.1282 19.0041 14.3728 18.642C14.6174 18.28 14.5222 17.7883 14.1602 17.5437C13.6753 17.2161 13.1088 17.043 12.5218 17.043C10.9066 17.043 9.59253 18.3571 9.59253 19.9723C9.59253 21.5875 10.9066 22.9015 12.5218 22.9015C13.1747 22.9015 13.7624 22.6855 14.2214 22.2766C14.3113 22.1967 14.3965 22.1087 14.4749 22.0152C14.7557 21.6806 14.7119 21.1817 14.3773 20.9009Z"
                fill="#2B2B2B"
            /> -->
            <!-- <path
                d="M25.3976 24.4596C25.1774 24.4624 24.9493 24.4647 24.7282 24.4664C24.9146 24.2101 25.1354 23.9015 25.3951 23.5304C25.6965 23.0998 25.886 22.7045 25.9746 22.3221C26.2229 21.1804 25.2856 20.0734 24.1252 20.086C23.2236 20.086 22.4432 20.7276 22.2696 21.6115C22.1854 22.0402 22.4647 22.4559 22.8934 22.5401C23.3219 22.6243 23.7379 22.345 23.822 21.9164C23.8502 21.7725 23.9777 21.6681 24.1252 21.6681C24.2975 21.6665 24.4584 21.8241 24.4254 21.997C24.3907 22.1238 24.3053 22.3284 24.099 22.6233C23.4216 23.5911 23.0177 24.12 22.8007 24.4041C22.5179 24.7744 22.3136 25.0419 22.4426 25.4615C22.5195 25.7114 22.7154 25.9106 22.9666 25.9943C23.0714 26.0293 23.1424 26.0529 24.0077 26.0529C24.3426 26.0529 24.7965 26.0494 25.4175 26.0416C25.8543 26.0361 26.204 25.6775 26.1985 25.2407C26.193 24.8038 25.8356 24.4565 25.3976 24.4596Z"
                fill="#2B2B2B"
            /> -->
            <!-- <path
                d="M18.4588 17.0637C16.844 17.0637 15.5299 18.3773 15.5299 19.9926C15.5299 21.6078 16.844 22.922 18.4588 22.922C20.074 22.922 21.3882 21.6078 21.3882 19.9926C21.3882 18.3773 20.074 17.0637 18.4588 17.0637ZM18.4588 21.34C17.7163 21.34 17.1119 20.7356 17.1119 19.9926C17.1119 19.2501 17.7163 18.6458 18.4588 18.6458C19.2018 18.6458 19.8061 19.2501 19.8061 19.9926C19.8061 20.7356 19.2018 21.34 18.4588 21.34Z"
                fill="#2B2B2B"
            /> -->
            <path
                d="M29.3383 18.855C28.4487 17.8932 27.2949 17.2424 26.0308 16.9782C26.0124 13.3443 23.0503 10.3938 19.4121 10.3938C17.3059 10.3938 15.3247 11.4089 14.086 13.0833C13.4073 12.8206 12.679 12.6835 11.9455 12.6835C8.68334 12.6835 6.02922 15.3376 6.02922 18.5998C6.02922 19.2632 6.14207 19.9245 6.35881 20.5483C4.92074 21.3815 4 22.9356 4 24.6352C4 27.2377 6.11729 29.355 8.71973 29.355H24.7457C28.194 29.355 31 26.549 31 23.1007C31 21.5213 30.4099 20.0136 29.3383 18.855ZM24.7457 27.7729H8.71973C6.98951 27.7729 5.58203 26.3655 5.58203 24.6352C5.58203 23.3174 6.41418 22.1314 7.65344 21.6832C8.09266 21.5363 8.30882 20.9843 8.08797 20.5779C7.77156 19.963 7.61125 19.2975 7.61125 18.5998C7.61125 16.2099 9.55557 14.2656 11.9455 14.2656C12.6621 14.2656 13.372 14.4438 13.9974 14.7808C14.3734 14.9838 14.8417 14.8514 15.0568 14.4823C15.9559 12.9367 17.625 11.9758 19.4121 11.9758C22.1891 11.9758 24.4488 14.2355 24.4488 17.0125C24.4488 17.1992 24.4388 17.3864 24.4182 17.5688C24.3618 17.9985 24.7065 18.4174 25.1391 18.4448C26.3019 18.5413 27.3808 19.0681 28.1771 19.9292C28.9771 20.7946 29.418 21.921 29.418 23.1007C29.418 25.6767 27.3218 27.7729 24.7457 27.7729Z"
                fill="url(#paint2_linear_24_404)"
            />
            <path
                d="M28.627 9.69141C27.3186 9.69141 26.2539 10.7561 26.2539 12.0645C26.2539 13.3728 27.3186 14.4375 28.627 14.4375C29.9353 14.4375 31 13.3728 31 12.0645C31 10.7561 29.9353 9.69141 28.627 9.69141ZM28.627 12.8555C28.1908 12.8555 27.8359 12.5006 27.8359 12.0645C27.8359 11.6283 28.1908 11.2734 28.627 11.2734C29.0631 11.2734 29.418 11.6283 29.418 12.0645C29.418 12.5006 29.0631 12.8555 28.627 12.8555Z"
                fill="url(#paint5_linear_24_404)"
            />
            <path
                d="M29.3383 18.855C28.4487 17.8932 27.2949 17.2424 26.0308 16.9782C26.0124 13.3443 23.0503 10.3938 19.4121 10.3938C17.3059 10.3938 15.3247 11.4089 14.086 13.0833C13.4073 12.8206 12.679 12.6835 11.9455 12.6835C8.68334 12.6835 6.02922 15.3376 6.02922 18.5998C6.02922 19.2632 6.14207 19.9245 6.35881 20.5483C4.92074 21.3815 4 22.9356 4 24.6352C4 27.2377 6.11729 29.355 8.71973 29.355H24.7457C28.194 29.355 31 26.549 31 23.1007C31 21.5213 30.4099 20.0136 29.3383 18.855ZM24.7457 27.7729H8.71973C6.98951 27.7729 5.58203 26.3655 5.58203 24.6352C5.58203 23.3174 6.41418 22.1314 7.65344 21.6832C8.09266 21.5363 8.30882 20.9843 8.08797 20.5779C7.77156 19.963 7.61125 19.2975 7.61125 18.5998C7.61125 16.2099 9.55557 14.2656 11.9455 14.2656C12.6621 14.2656 13.372 14.4438 13.9974 14.7808C14.3734 14.9838 14.8417 14.8514 15.0568 14.4823C15.9559 12.9367 17.625 11.9758 19.4121 11.9758C22.1891 11.9758 24.4488 14.2355 24.4488 17.0125C24.4488 17.1992 24.4388 17.3864 24.4182 17.5688C24.3618 17.9985 24.7065 18.4174 25.1391 18.4448C26.3019 18.5413 27.3808 19.0681 28.1771 19.9292C28.9771 20.7946 29.418 21.921 29.418 23.1007C29.418 25.6767 27.3218 27.7729 24.7457 27.7729Z"
                fill="url(#paint6_linear_24_404)"
                fill-opacity="0.23"
            />
            <path
                d="M11.656 6C10.3477 6 9.28296 7.06471 9.28296 8.37305C9.28296 9.68139 10.3477 10.7461 11.656 10.7461C12.9643 10.7461 14.0291 9.68139 14.0291 8.37305C14.0291 7.06471 12.9643 6 11.656 6ZM11.656 9.16406C11.2199 9.16406 10.865 8.80916 10.865 8.37305C10.865 7.93693 11.2199 7.58203 11.656 7.58203C12.0921 7.58203 12.447 7.93693 12.447 8.37305C12.447 8.80916 12.0921 9.16406 11.656 9.16406Z"
                fill="url(#paint4_linear_24_404)"
            />
            <path
                d="M28.627 9.69141C27.3186 9.69141 26.2539 10.7561 26.2539 12.0645C26.2539 13.3728 27.3186 14.4375 28.627 14.4375C29.9353 14.4375 31 13.3728 31 12.0645C31 10.7561 29.9353 9.69141 28.627 9.69141ZM28.627 12.8555C28.1908 12.8555 27.8359 12.5006 27.8359 12.0645C27.8359 11.6283 28.1908 11.2734 28.627 11.2734C29.0631 11.2734 29.418 11.6283 29.418 12.0645C29.418 12.5006 29.0631 12.8555 28.627 12.8555Z"
                fill="url(#paint5_linear_24_404)"
            />
            <path
                d="M21.3796 8.36645C21.8165 8.36645 22.1707 8.01231 22.1707 7.57544C22.1707 7.13857 21.8165 6.78442 21.3796 6.78442C20.9428 6.78442 20.5886 7.13857 20.5886 7.57544C20.5886 8.01231 20.9428 8.36645 21.3796 8.36645Z"
                fill="url(#paint7_linear_24_404)"
            />
            <path
                d="M30.209 7.76672C30.6459 7.76672 31 7.41257 31 6.97571C31 6.53884 30.6459 6.18469 30.209 6.18469C29.7721 6.18469 29.418 6.53884 29.418 6.97571C29.418 7.41257 29.7721 7.76672 30.209 7.76672Z"
                fill="url(#paint7_linear_24_404)"
            />
            <path
                d="M6.68127 12.2126C7.11814 12.2126 7.47229 11.8585 7.47229 11.4216C7.47229 10.9848 7.11814 10.6306 6.68127 10.6306C6.24441 10.6306 5.89026 10.9848 5.89026 11.4216C5.89026 11.8585 6.24441 12.2126 6.68127 12.2126Z"
                fill="url(#paint8_linear_24_404)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_24_404"
                x1="17.5"
                y1="10.39"
                x2="17.5"
                y2="29.3512"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#E8E8E8" />
                <stop offset="1" stop-color="#D8D8D8" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_24_404"
                x1="17.5"
                y1="10.3938"
                x2="28.5"
                y2="30.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset="1" stop-color="#E0E0E0" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_24_404"
                x1="17.5"
                y1="10.3938"
                x2="28.5"
                y2="30.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#ECECEC" stop-opacity="0.64" />
                <stop offset="1" stop-color="#E0E0E0" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_24_404"
                x1="28.627"
                y1="9.69141"
                x2="28.627"
                y2="14.4375"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#D8D8D8" />
                <stop offset="1" stop-color="#C8C8C8" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_24_404"
                x1="11.656"
                y1="6"
                x2="11.656"
                y2="10.7461"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#D8D8D8" />
                <stop offset="1" stop-color="#E0E0E0" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_24_404"
                x1="28.627"
                y1="9.69141"
                x2="28.627"
                y2="14.4375"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#D8D8D8" />
                <stop offset="1" stop-color="#C8C8C8" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_24_404"
                x1="17.5"
                y1="10.3938"
                x2="28.5"
                y2="30.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#ECECEC" />
                <stop offset="1" stop-color="#E0E0E0" />
            </linearGradient>
            <linearGradient
                id="paint7_linear_24_404"
                x1="21.3796"
                y1="6.78442"
                x2="21.3796"
                y2="8.36645"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#D8D8D8" />
                <stop offset="1" stop-color="#E0E0E0" />
            </linearGradient>
            <linearGradient
                id="paint8_linear_24_404"
                x1="6.68127"
                y1="10.6306"
                x2="6.68127"
                y2="12.2126"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#E0E0E0" />
                <stop offset="1" stop-color="#C8C8C8" />
            </linearGradient>
            <clipPath id="clip0_24_404">
                <rect width="36" height="36" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "Co2Icon",
};
</script>
